import _ from "lodash";
import { useEffect, useState } from "react";
import Cell from "./Cell";
import { initBoard, revealEmpty } from "../helper/boardHelper";

const Board = () => {
  const [board, setBoard] = useState([]);
  const [flags, setFlags] = useState(10);
  const [message, setMessage] = useState("Minesweeper");
  const [gameOver, setGameOver] = useState(false);

  useEffect(() => {
    if (board.length === 0) {
      setBoard(initBoard());
    }
  }, [board.length]);

  const checkWinner = (board) => {
    if (
      _.flatten(board).reduce(
        (prev, curr) => prev && (curr.revealed || curr.isMine),
        true
      )
    ) {
      setMessage("You won!");
      setGameOver(true);
    }
  };

  const revealCell = (x, y) => {
    if (!board[x][y].flagged && !board[x][y].revealed && !gameOver) {
      let newBoard = _.cloneDeep(board);
      if (board[x][y].neighborMines === 0 && !board[x][y].isMine) {
        revealEmpty(newBoard, x, y);
      }
      newBoard[x][y].revealed = true;
      if (newBoard[x][y].isMine) {
        setMessage("You lost!");
        setGameOver(true);
      }
      checkWinner(newBoard);
      setBoard(newBoard);
    }
  };

  const updateFlag = (x, y) => {
    if (
      !board[x][y].flagged &&
      flags > 0 &&
      !board[x][y].revealed &&
      !gameOver
    ) {
      let newBoard = _.cloneDeep(board);
      newBoard[x][y].flagged = true;
      setBoard(newBoard);
      setFlags(flags - 1);
    }
    if (board[x][y].flagged && !board[x][y].revealed && !gameOver) {
      let newBoard = _.cloneDeep(board);
      newBoard[x][y].flagged = false;
      setBoard(newBoard);
      setFlags(flags + 1);
    }
  };

  const newGame = () => {
    setBoard(initBoard());
    setGameOver(false);
    setMessage("Minesweeper");
    setFlags(10);
  };

  return (
    <div className="board">
      <div className="message-lbl">{message}</div>
      <div className="mines-lbl">Mines remaining: {flags}</div>
      <div className="grid-wrapper">
        {board.map((row, i) =>
          row.map((cellData, j) => (
            <Cell
              key={i * 8 + j}
              {...cellData}
              x={i}
              y={j}
              revealCell={revealCell}
              updateFlag={updateFlag}
            />
          ))
        )}
      </div>
      {gameOver && <button onClick={newGame}>Play again?</button>}
    </div>
  );
};

export default Board;
